import React, { useEffect, useRef, useState } from "react";
import * as XLSX from 'xlsx';
import { GetAllClientsUAPI, preOnboardDevices, ValidationfBulkDevicePreOnboard } from "../../../services/configurationServices";
import { getSiteList } from "../../../services/alertGridServices";
import { Tabs, Tab, Box, Button, Chip } from "@mui/material";
import { getAllFilters } from '../../../services/configurationServices'


import Swal from "sweetalert2";
const onvif_template_link ="/bulkImportTemplates/MH_ONVIF_Device_Bulk_Import_Template.xlsx";

const PreOnboardDevices = () => {
  const [activeTab, setActiveTab] = useState(0);  
  const hiddenPanelFileInput = useRef(null);
  const codeRef = useRef(null);
  const textRef = useRef();
  const [headers, setHeaders] = useState(null);
  const [copied, setCopied] = useState(false);
  const [isBlankSheet, setIsBlankSheet] = useState(false);
  const [importedFileName, setImportedFileName] = useState(null);
  const [errors, setErrors] = useState({
    selectedcustomer: "",
    selectedSite: "",
    ipAddress: "",
    port: "",
    onvifUsername: "",
    onvifPassword: "",
    deviceName: "",
  });
  const [customerList, setCustomerList] = useState([]);
  const [selectedcustomer, setSelectedCustomer] = useState(0);
  const [selectedSite, setSelectedSite] = useState(0);
  const [siteList, setSiteList] = useState([]);
  const [ipAddress, setIPAddress] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [port, setPort] = useState("");
  const [onvifUsername, setOnvifUsername] = useState("");
  const [onvifPassword, setOnvifPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState([]);
  // Added state for bulk upload data and validation status
  const [bulkFileData, setBulkFileData] = useState([]);
  const [isBulkValid, setIsBulkValid] = useState(false);

  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  const userId = loggedInUser?.Id;
  const OrganizationMasterID = loggedInUser?.OrganizationMasterID;

  const handleFile = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Get the first sheet
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert sheet to JSON, just the first row
      const headers = [];
      const range = XLSX.utils.decode_range(worksheet["!ref"]);

      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: range.s.r, c: C });
        const cell = worksheet[cellAddress];
        const header = cell ? cell.v : `UNKNOWN ${C}`;
        headers.push(header);
      }
      setHeaders(headers);
    };

    reader.readAsArrayBuffer(file);
  };

  const checkExcelHasData = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // For example, checking the first sheet
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert entire sheet to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        defval: "",
        raw: true,
      });
      if (jsonData.length > 0) {
        setIsBlankSheet(false);
      } else {
        setIsBlankSheet(true);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleCopy = () => {
    const text = textRef.current.innerText;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

const handleExcelFile = async (e, shouldValidate = true) => {
  const file = e.target.files[0];
  if (!file) return;

  const data = await file.arrayBuffer();
  const workbook = XLSX.read(data, { type: 'array' });
  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];

  const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '', header: 1 });
  
  // Extract rows with actual Excel row numbers
  const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1');
  const headers = [];
  
  // Get headers from first row
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
    const cell = worksheet[cellAddress];
    const header = cell ? cell.v : `UNKNOWN ${C}`;
    headers.push(header);
  }
  
  // Parse data rows with actual Excel row numbers
  const dataWithRowNums = [];
  for (let R = range.s.r + 1; R <= range.e.r; ++R) {
    const row = {};
    let isEmpty = true;
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = worksheet[cellAddress];
      const headerName = headers[C - range.s.c];
      row[headerName] = cell ? cell.v : '';
      if (cell && cell.v && String(cell.v).trim()) isEmpty = false;
    }
    // Only include non-empty rows and store actual Excel row number (R+1 for 1-based indexing)
    if (!isEmpty) {
      dataWithRowNums.push({ ...row, _excelRowNum: R + 1 });
    }
  }
  
  const trimmedData = trimObjectValues(dataWithRowNums);

  setBulkFileData(trimmedData);
  setImportedFileName(file.name);

  // Only validate if shouldValidate is true (when called from Validate button)
  if (shouldValidate) {
    // Validate the parsed data and update error messages
    const validated = validateDeviceData(trimmedData);
    setErrorMessage(validated.errors);
    setIsBulkValid(validated.isValid);

    if (!validated.isValid) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Failed',
        html: `Please fix ${validated.errors.length} error(s) before continuing.`,
      });
    }
  }
};

const trimObjectValues = (objArray) =>
  objArray.map((obj) => ({
    ...Object.fromEntries(
      Object.entries(obj)
        .filter(([key]) => key !== '_excelRowNum')
        .map(([key, val]) => [key.trim(), String(val).trim()])
    ),
    _excelRowNum: obj._excelRowNum // Preserve the Excel row number
  }));

const isValidPort = (port) => {
  const num = Number(port);
  return Number.isInteger(num) && num >= 1 && num <= 65535;
};

const validateDeviceData = (data) => {
  const errors = [];

  if (!Array.isArray(data) || data.length === 0) {
    errors.push({ message: 'Uploaded file has no rows' });
    return { isValid: false, errors };
  }

  // Define exact required column names for strict validation
  const requiredFields = ['Customer', 'Site', 'Device Name', 'IP Address', 'Port', 'Onvif Username', 'Onvif Password'];
  const headerKeys = Object.keys(data[0]).filter(k => k !== '_excelRowNum').map((key) => key.trim());
  const headerSet = new Set(headerKeys);

  // Check for missing or extra columns
  const missingHeaders = requiredFields.filter((col) => !headerSet.has(col));
  const extraHeaders = headerKeys.filter((col) => !requiredFields.includes(col));

  if (missingHeaders.length > 0) {
    missingHeaders.forEach((col) => errors.push({ message: `Missing required column: ${col}` }));
  }
  if (extraHeaders.length > 0) {
    extraHeaders.forEach((col) => errors.push({ message: `Unrecognized column: ${col}` }));
  }

  const seenDevices = new Set();

  data.forEach((row) => {
    // Use actual Excel row number if available, otherwise calculate from index
    const rowNo = row._excelRowNum || (data.indexOf(row) + 2);
    const getVal = (names) => {
      for (const name of names) {
        if (row[name] !== undefined && String(row[name]).trim() !== '') {
          return String(row[name]).trim();
        }
      }
      return '';
    };

    const customer = getVal(['customer', 'Customer']);
    const site = getVal(['site', 'Site']);
    const ipAddress = getVal(['ipAddress', 'IP Address', 'IP']);
    const port = getVal(['port', 'Port']);
    const onvifUsername = getVal(['Onvif Username', 'onvifusername', 'OnvifUsername', 'ONVIFUsername']);
    const onvifPassword = getVal(['Onvif Password', 'onvifpassword', 'OnvifPassword', 'ONVIFPassword']);
    const deviceName = getVal(['deviceName', 'DeviceName', 'Device Name']);

    if (!customer) errors.push({ message: `Row ${rowNo}: customer is required` });
    if (!site) errors.push({ message: `Row ${rowNo}: site is required` });
    if (!ipAddress) errors.push({ message: `Row ${rowNo}: ipAddress is required` });
    else if (!isValidIP(ipAddress)) errors.push({ message: `Row ${rowNo}: ipAddress is invalid` });
    if (!port) errors.push({ message: `Row ${rowNo}: port is required` });
    else if (!isValidPort(port)) errors.push({ message: `Row ${rowNo}: port must be an integer 1-65535` });
    if (!onvifUsername) errors.push({ message: `Row ${rowNo}: onvifUsername is required` });
    else if (onvifUsername.includes(' ')) errors.push({ message: `Row ${rowNo}: onvifUsername cannot contain spaces` });
    if (!onvifPassword) errors.push({ message: `Row ${rowNo}: onvifPassword is required` });
    else if (onvifPassword.includes(' ')) errors.push({ message: `Row ${rowNo}: onvifPassword cannot contain spaces` });
    if (!deviceName) errors.push({ message: `Row ${rowNo}: deviceName is required` });

    const signature = `${customer}:${ipAddress}:${port}`;
    if (seenDevices.has(signature)) {
      errors.push({ message: `Row ${rowNo}: duplicate device (customer+ip+port)` });
    } else {
      seenDevices.add(signature);
    }
  });

  return { isValid: errors.length === 0, errors };
};
const isValidIP = (ip) => {
  const ipv4 = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
  const ipv6 = /^(([0-9a-fA-F]{0,4}:){1,7}[0-9a-fA-F]{0,4})$/;
  return ipv4.test(ip) || ipv6.test(ip);
};

const handleBulkValidate = async () => {
  if (!bulkFileData || bulkFileData.length === 0) {
    setErrorMessage([{ message: 'No file loaded. Please upload Excel and then click Validate.' }]);
    setIsBulkValid(false);
    return;
  }

  // First, perform client-side validation
  const validated = validateDeviceData(bulkFileData);
  if (!validated.isValid) {
    setErrorMessage(validated.errors);
    setIsBulkValid(false);
    Swal.fire({ icon: 'error', title: 'Validation Failed', text: `${validated.errors.length} error(s) found.` });
    return;
  }

  // If client-side validation passes, call the API for server-side validation

      // Prepare payload with exact column mappings and port as string
  const payloadRows = bulkFileData.map((row) => ({
    customer: (row.Customer || row.customer || '').toString().trim(),
    site: (row.Site || row.site || '').toString().trim(),
    deviceName: (row['Device Name'] || row.DeviceName || row.deviceName || '').toString().trim(),
    ipAddress: (row['IP Address'] || row.ipAddress || row.IPAddress || '').toString().trim(),
    port: (row.Port || row.port || '').toString().trim(),
    onvifusername: (row['Onvif Username'] || row.onvifUsername || row.onvifusername || '').toString().trim(),
    onvifpassword: (row['Onvif Password'] || row.onvifPassword || row.onvifpassword || '').toString().trim(),
  }));

  const payload = {
    userID: userId,
    organizationMasterID: OrganizationMasterID,
    data: payloadRows,
  };

  ValidationfBulkDevicePreOnboard(payload)
    .then((res) => {
      const successCount = res?.Data?.successList?.length || 0;
      const failedList = res?.Data?.failedList || [];

      if (successCount > 0) {
        Swal.fire({ icon: 'success', title: 'Bulk Validation Completed', text: `${successCount} records validated successfully.` });
      }

      // If API returns failures, display them in the error panel with correct Excel row numbers
      if (failedList.length > 0) {
        const rowMessages = failedList.map((item, idx) => {
          // Find the corresponding row in bulkFileData to get the actual Excel row number
          const originalRow = bulkFileData.find(row => 
            (row.Customer || row.customer) === item.customer && 
            (row.Site || row.site) === item.site && 
            (row['Device Name'] || row.DeviceName || row.deviceName) === item.deviceName
          );
          const rowNum = originalRow?._excelRowNum || (idx + 1);
          return {
            message: `Row ${rowNum} (${item.customer} / ${item.site} / ${item.deviceName}): ${item.message}`,
          };
        });

        setErrorMessage(rowMessages);
        setIsBulkValid(false);

        Swal.fire({
          icon: 'error',
          title: 'Bulk Validation Failed',
          html: `${failedList.length} rows failed validation. See details in validation panel.`,
        });
      }

      if (successCount === 0 && failedList.length === 0) {
        Swal.fire({ icon: 'warning', title: 'Bulk Validation', text: 'No records were validated successfully.' });
        setIsBulkValid(false);
      }

      // Enable button only if validation is fully successful
      if (successCount > 0 && failedList.length === 0) {
        setIsBulkValid(true);
      }
    })
    .catch((err) => {
      console.error('Bulk pre-onboard failed', err);
      Swal.fire({ icon: 'error', title: 'Bulk Pre-Onboard Failed', text: 'Please try again.' });
    });


};

const handleBulkPreOnboard = () => {
  if (!isBulkValid) {
    Swal.fire({ icon: 'warning', title: 'Validate First', text: 'Please validate uploaded data before pre-onboarding.' });
    return;
  }

  // Prepare payload with exact column mappings and port as string
  const payloadRows = bulkFileData.map((row) => ({
    customer: (row.Customer || row.customer || '').toString().trim(),
    site: (row.Site || row.site || '').toString().trim(),
    deviceName: (row['Device Name'] || row.DeviceName || row.deviceName || '').toString().trim(),
    ipAddress: (row['IP Address'] || row.ipAddress || row.IPAddress || '').toString().trim(),
    port: (row.Port || row.port || '').toString().trim(),
    onvifusername: (row['Onvif Username'] || row.onvifUsername || row.onvifusername || '').toString().trim(),
    onvifpassword: (row['Onvif Password'] || row.onvifPassword || row.onvifpassword || '').toString().trim(),
  }));

  const payload = {
    userID: userId,
    organizationMasterID: OrganizationMasterID,
    data: payloadRows,
  };

  preOnboardDevices(payload)
    .then((res) => {
      const successCount = res?.Data?.successList?.length || 0;
      const failedList = res?.Data?.failedList || [];

      if (successCount > 0) {
        Swal.fire({ icon: 'success', title: 'Bulk Pre-Onboard Completed', text: `${successCount} records Pre-Onboarded.` });
      }

      // If API returns failures, display them in the error panel with correct Excel row numbers
      if (failedList.length > 0) {
        const rowMessages = failedList.map((item, idx) => {
          // Find the corresponding row in bulkFileData to get the actual Excel row number
          const originalRow = bulkFileData.find(row => 
            (row.Customer || row.customer) === item.customer && 
            (row.Site || row.site) === item.site && 
            (row['Device Name'] || row.DeviceName || row.deviceName) === item.deviceName
          );
          const rowNum = originalRow?._excelRowNum || (idx + 1);
          return {
            message: `Row ${rowNum} (${item.customer} / ${item.site} / ${item.deviceName}): ${item.message}`,
          };
        });

        setErrorMessage(rowMessages);
        setIsBulkValid(false);

        Swal.fire({
          icon: 'error',
          title: 'Bulk Pre-Onboard Partial/Complete Failure',
          html: `${failedList.length} rows failed. See details in validation panel.`,
        });
      }

      if (successCount === 0 && failedList.length === 0) {
        Swal.fire({ icon: 'warning', title: 'Bulk Pre-Onboard', text: 'No records were Pre-Onboarded successfully.' });
      }

      // Reset state only on full success
      if (successCount > 0 && failedList.length === 0) {
        setBulkFileData([]);
        setErrorMessage([]);
        setImportedFileName(null);
        setIsBulkValid(false);
      }
    })
    .catch((err) => {
      console.error('Bulk pre-onboard failed', err);
      Swal.fire({ icon: 'error', title: 'Bulk Pre-Onboard Failed', text: 'Please try again.' });
    });
};

    const handleUploaderChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setImportedFileName(file.name);
        setBulkFileData([]);
        setErrorMessage([]);
        setIsBulkValid(false);  // Disable the Bulk Pre-Onboard button when new file is selected

        checkExcelHasData(file);
        handleFile(file);

        // Parse the file but don't validate automatically - user must click Validate button
        await handleExcelFile(e, false); // parse only, no validation
      }

  const validate = (field, value) => {
    const val = String(value ?? "").trim();
    let message = "";

    switch (field) {
      case "selectedcustomer":
        if (val === "" || val === "0") message = "Customer is required.";
        break;
      case "selectedSite":
        if (val === "" || val === "0") message = "Site is required.";
        break;
      case "deviceName":
        if (val === "") message = "Device Name is required.";
        break;
      case "ipAddress":
        if (val === "") message = "IP Address is required.";
        else if (!isValidIP(val)) message = "Invalid IP address (IPv4 or IPv6 required).";
        break;
      case "port":
        if (val === "") message = "Port is required.";
        else if (!isValidPort(val)) message = "Port must be an integer between 1 and 65535.";
        break;
      case "onvifUsername":
        if (val === "") message = "ONVIF Username is required.";
        else if (val.includes(" ")) message = "ONVIF Username cannot contain spaces.";
        break;
      case "onvifPassword":
        if (val === "") message = "ONVIF Password is required.";
        else if (val.includes(" ")) message = "ONVIF Password cannot contain spaces.";
        break;
      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [field]: message,
    }));
  };

  const isFormValid =
    selectedcustomer !== 0 &&
    selectedSite !== 0 &&
    deviceName.trim() !== "" &&
    isValidIP(ipAddress.trim()) &&
    isValidPort(port.trim()) &&
    onvifUsername.trim() !== "" &&
    !onvifUsername.includes(" ") &&
    onvifPassword.trim() !== "" &&
    !onvifPassword.includes(" ");

  const downloadOnvifTemplate = async () => {
    const link = document.createElement("a");
    link.href = onvif_template_link;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    const {Data} = await getAllFilters({ Entity: 'Interface' });
    // console.log("Original Data:", Data);
    // Filter out rows where ClientId or SiteID is null
    const filteredData = Data.filter(item => item.ClientId != null && item.SiteID != null);
    // Map to only ClientName and SiteName
    const exportData = filteredData.map(item => ({
      Customer: item.ClientName,
      Site: item.SiteName
    }));

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'ClientSiteData');
    // Download the file
    XLSX.writeFile(workbook, 'CustomerSite_MasterData.xlsx');
    setTimeout(() => {
      Swal.fire({
        icon: "info",
        title: "Template Downloaded",
        html: `<p><strong>The downloaded template contains dummy data.</strong> Please remove it and enter your actual data before uploading.</p>
               <p>You may refer to the dummy data as examples to understand the expected format and valid values.</p>`,
      });
    }, 500);
  };

  const clearFormFields = () => {
    setSelectedCustomer(0);
    setSelectedSite(0);
    setIPAddress("");
    setPort("");
    setOnvifUsername("");
    setOnvifPassword("");
    setDeviceName("");
    setErrors({
      selectedcustomer: "",
        selectedSite: "",
        ipAddress: "",
        port: "",
        onvifUsername: "",
        onvifPassword: "",
        deviceName: "",
    });
  }

  const handleBrowse = (event) => {
    event.preventDefault();
    hiddenPanelFileInput.current.click();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const payload = {
        userID:userId,
        organizationMasterID:OrganizationMasterID,
        data:[{
            customer: selectedcustomer.split(",")[1],
            site: selectedSite.split(",")[1],
            deviceName: deviceName, 
            ipAddress: ipAddress,
            port: port,
            onvifusername: onvifUsername,
            onvifpassword: onvifPassword
    }]
        
    }

    // First, validate the device
    ValidationfBulkDevicePreOnboard(payload)
      .then((res) => {
        const successCount = res?.Data?.successList?.length || 0;
        const failedList = res?.Data?.failedList || [];

        if (successCount > 0) {
          // Validation successful, proceed to pre-onboard
          preOnboardDevices(payload)
            .then((preRes) => {
              const preSuccessCount = preRes?.Data?.successList?.length || 0;
              const preFailedList = preRes?.Data?.failedList || [];

              if (preSuccessCount > 0) {
                Swal.fire({
                  icon: "success",
                  title: "Device Pre-Onboarded Successfully",
                  text: preRes.Data.successList[0].deviceName + " has been pre-onboarded successfully."
                });
                clearFormFields();
              } else if (preFailedList.length > 0) {
                Swal.fire({
                  icon: 'error',
                  title: 'Failed to Pre-Onboard Device',
                  text: preFailedList[0]?.message,
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Failed to Pre-Onboard Device",
                  text: "An error occurred while pre-onboarding the device."
                });
              }
            })
            .catch((err) => {
              console.error("Error occurred while pre-onboarding device:", err);
              Swal.fire({
                icon: "error",
                title: "Failed to Pre-Onboard Device",
                text: "An error occurred while pre-onboarding the device."
              });
            });
        } else if (failedList.length > 0) {
          Swal.fire({
            icon: 'error',
            title: 'Validation Failed',
            text: failedList[0]?.message,
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Validation Failed',
            text: 'Validation failed for unknown reasons.',
          });
        }
      })
      .catch((err) => {
        console.error('Validation failed', err);
        Swal.fire({
          icon: 'error',
          title: 'Validation Failed',
          text: 'An error occurred during validation.',
        });
      });
  };

  useEffect(() => {
    GetAllClientsUAPI(userId).then((res) => {
      if (res && res.Data) {
        setCustomerList(res.Data);
      }
    });
  }, [userId]);

  const handleCustomerChange = (e) => {
    setSelectedCustomer(e.target.value);
    setSelectedSite(0)
    getSiteList(e.target.value.split(",")[0]).then((res) => {
      if (res && res.Data) {
        setSiteList(res.Data);
      }else{
        setSiteList([])
      }
    });
    validate("selectedcustomer", e.target.value);
  }

  return (
    <div className="p-3">
      <div className="SiteMainContainer SiteTableMainDiv">
            {/* Add your form components here */}

                          <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <Tabs
                                  value={activeTab}
                                  onChange={(e, val) => setActiveTab(val)}
                                  textColor="primary"
                                  indicatorColor="primary"
                              >
                                  <Tab label="Single Device Upload" style={{ fontWeight: "700", textTransform: "none" }} />
                                  <Tab label="Bulk Device Upload" style={{ fontWeight: "700" , textTransform: "none" }} />
                              </Tabs>
                          </Box>

                          {/* Tab Content */}
                          <Box className="p-3">
                              {activeTab === 0 && <>
                              
                                  <form style={{ width: "100%" }}>
                                    <div className="SiteFormAdditionForm" style={{borderTop:"1px", height:"calc(100vh - 285px)"}}>
                                      <div className="site-form" style={{ height: "calc(100vh - 300px)" }}>
                                          <div className="inputMainContainer w40dot75rem mt35">
                                              <div className="inputTypeLabelContainer">
                                                  <label className="formFieldLabels">
                                                      Select Customer*
                                                  </label>
                                                  <select
                                                      className="inputType ArrowSelectClass"
                                                      value={selectedcustomer}
                                                      onChange={ (e) => handleCustomerChange(e)}
                                                  >
                                                      <option value="0">Select Customer*</option>
                                                      {[...customerList]
                                                          .sort((a, b) => a.ClientName.localeCompare(b.ClientName))
                                                          .map((c) => (
                                                              <option key={c.ClientId} value={[c.ClientId,c.ClientName]}>
                                                                  {c.ClientName}
                                                              </option>
                                                          ))}
                                                  </select>
                                                  <p className="Error_P" style={{ float: "left" }}>
                                                      <span>{errors.selectedcustomer}</span>
                                                  </p>
                                              </div>
                                          </div>

                                          <div className="inputMainContainer w40dot75rem mt35">
                                              <div className="inputTypeLabelContainer">
                                                  <label className="formFieldLabels">
                                                      Select Site*
                                                  </label>
                                                  <select
                                                      className="inputType ArrowSelectClass"
                                                      value={selectedSite}
                                                      onChange={(e) => { setSelectedSite(e.target.value); validate("selectedSite", e.target.value); }}
                                                  >
                                                      <option value="0">Select Site*</option>
                                                      {[...siteList]
                                                          .sort((a, b) => a.SiteName.localeCompare(b.SiteName))
                                                        .filter(f => f.SiteID != null && f.ParentID == null)
                                                          .map((c) => (
                                                              <option key={c.SiteID} value={[c.SiteID,c.SiteName]}>
                                                                  {c.SiteName}
                                                              </option>
                                                          ))}
                                                  </select>
                                                  <p className="Error_P" style={{ float: "left" }}>
                                                      <span>{errors.selectedSite }</span>
                                                  </p>
                                              </div>
                                          </div>

                                          <div className="inputMainContainer w40dot75rem mt35">
                                              <div className="inputTypeLabelContainer">
                                                  <label className="formFieldLabels">Device Name*</label>
                                                  <input
                                                      className="inputType"
                                                      placeholder="Enter Device Name"
                                                      value={deviceName}
                                                      onChange={(e) => { setDeviceName(e.target.value); validate("deviceName", e.target.value); }}
                                                  />
                                                  <p className="Error_P" style={{ float: "left" }}>
                                                      <span>{errors.deviceName }</span>
                                                  </p>
                                              </div>
                                          </div>

                                          <div className="inputMainContainer w40dot75rem mt35">
                                              <div className="inputTypeLabelContainer">
                                                  <label className="formFieldLabels">IP Address*</label>
                                                  <input
                                                      className="inputType"
                                                      placeholder="Enter IPAddress"
                                                      value={ipAddress}
                                                      onChange={(e) => { setIPAddress(e.target.value); validate("ipAddress", e.target.value); }}
                                                  />
                                                  <p className="Error_P" style={{ float: "left" }}>
                                                      <span>{errors.ipAddress}</span>
                                                  </p>
                                              </div>
                                          </div>
                                          <div className="inputMainContainer w40dot75rem mt35">
                                              <div className="inputTypeLabelContainer">
                                                  <label className="formFieldLabels">Port*</label>
                                                  <input
                                                      className="inputType"
                                                      placeholder="Enter Port*"
                                                      value={port}
                                                      onChange={(e) => { setPort(e.target.value); validate("port", e.target.value); }}
                                                  />
                                                  <p className="Error_P" style={{ float: "left" }}>
                                                      <span>{errors.port}</span>
                                                  </p>
                                              </div>
                                          </div>

                                          <div className="inputMainContainer w40dot75rem mt35">
                                              <div className="inputTypeLabelContainer">
                                                  <label className="formFieldLabels">OnVif Username*</label>
                                                  <input
                                                      className="inputType"
                                                      placeholder="Enter Username*"
                                                      value={onvifUsername}
                                                      onChange={(e) => { setOnvifUsername(e.target.value); validate("onvifUsername", e.target.value); }}
                                                  />
                                                  <p className="Error_P" style={{ float: "left" }}>
                                                      <span>{errors.onvifUsername}</span>
                                                  </p>
                                              </div>
                                          </div>
                                          <div className="inputMainContainer w40dot75rem mt35">
                                              <div className="inputTypeLabelContainer">
                                                  <label className="formFieldLabels">OnVif Password*</label>
                                                  <input
                                                      className="inputType"
                                                      placeholder="Enter Password*"
                                                      value={onvifPassword}
                                                      onChange={(e) => { setOnvifPassword(e.target.value); validate("onvifPassword", e.target.value); }}
                                                  />
                                                  <p className="Error_P" style={{ float: "left" }}>
                                                      <span>{errors.onvifPassword}</span>
                                                  </p>
                                              </div>
                                          </div>
                                      </div>
                                    </div>

                                      <div style={{ textAlign: "center" }}>
                                          <button className="DataAccessEdit" style={{ width: "150px" }} disabled={!isFormValid} onClick={(e) => handleSubmit(e)}>
                                              <span className="ViewUpdate">Submit</span>
                                          </button>
                                          {/* <input
                                              type="file"
                                              accept='.xlsx, .xls, .csv'
                                              multiple={false}
                                              ref={hiddenPanelFileInput}
                                              //onChange={(e) => handleUploaderChange(e)}
                                              style={{ display: "none" }}
                                              value=""
                                          />
                                          <button className="DataAccessEdit" onClick={handleBrowse} style={{ width: "150px" }}>
                                              <span className="ViewUpdate">Bulk Pre-Onboard</span>
                                          </button> */}
                                          {/* <input
                                            type="file"
                                            accept=".xlsx, .xls, .csv"
                                            multiple={false}
                                            ref={hiddenPanelFileInput}
                                            //onChange={(e) => handleUploaderChange(e)}
                                            style={{ display: "none" }}
                                            value=""
                                        /> */}
                                                                    {/* <button
                                            className="DataAccessEdit"
                                            style={{ width: "150px" }}
                                            onClick={handleBrowse}
                                        >
                                            <span className="ViewUpdate">Bulk Pre-Onboard</span>
                                        </button> */}
                                      </div>    
                                  </form>

                              </>}
                              {activeTab === 1 && <>
                               <div className="SiteFormAdditionForm" style={{borderTop:"1px", height:"calc(100vh - 285px)"}}>
                                 <div className="site-form" style={{ height: "calc(100vh - 300px)" }}>
                                    <div className="bulk-container">
                                        <h3 className="bulk-title">Bulk Pre-Onboard</h3>
                                        <p className="bulk-subtitle">
                                            Download template, fill device details, upload file and onboard devices.
                                        </p>

                                        {/* STEP 1 */}
                                        <div className="bulk-card">
                                            <div className="step-header">
                                                <span className="step-number">1</span>
                                                <h5>Download Template</h5>
                                            </div>

                                            <div style={{ textAlign: "left" }}>
                                                <button className="primary-btn" onClick={downloadOnvifTemplate}>
                                                    Download Excel Template
                                                </button>
                                            </div>
                                            
                                        </div>

                                        {/* STEP 2 */}
                                        <div className="bulk-card">
                                            <div className="step-header">
                                                <span className="step-number">2</span>
                                                <h5>Upload File</h5>
                                            </div>

                                            <div className="upload-row">
                                                <input
                                                    className="file-input"
                                                    value={importedFileName || "No file selected"}
                                                    disabled
                                                />

                                                <input
                                                    type="file"
                                                    accept='.xlsx, .xls, .csv'
                                                    multiple={false}
                                                    ref={hiddenPanelFileInput}
                                                    onChange={(e) => handleUploaderChange(e)}
                                                    style={{ display: "none" }}
                                                    value=""

                                                />

                                               
                                                <button
                                                className="DataAccessEdit"
                                                style={{ width: "100px", height: "40px" }}
                                                onClick={handleBrowse}>
                                                    <span className="ViewUpdate">Browse</span>
                                                </button>
                                                {/* Added Validate button to manually trigger validation after file upload */}
                                                <button
                                                    className="DataAccessEdit"
                                                    style={{ width: "100px", height: "40px" }}
                                                    disabled={!importedFileName}
                                                    onClick={handleBulkValidate}
                                                >
                                                    <span className="ViewUpdate">Validate</span>
                                                </button>
                                            </div>
                                        </div>



                                        <div className="col-lg-12 mt-2 p-0" style={{ width: "100%" }}>
                                            {/* <AlertTemplateMessage
                                                    message={
                                                        "Error comes here."
                                                    }
                                                    /> */}
                                            <div className="code-snippet-container" style={{height:"300px"}}>
                                            <button onClick={handleCopy} className="copy-button">
                                                {copied ? "Copied!" : "Copy"}
                                            </button>
                                            <div
                                                ref={textRef}
                                                style={{
                                                color: "black",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "start",
                                                }}
                                            >
                                                {errorMessage.map((item, index) => (
                                                <div
                                                    style={{
                                                    display: "flex",
                                                    textAlign: "left",
                                                    }}
                                                    className="childError"
                                                    key={index}
                                                >
                                                    {item.message}
                                                </div>
                                                ))}
                                            </div>

                                            <pre ref={codeRef}>
                                                {/* {
                                                errorMessage.map((item, index) => (
                                                    <code key={index}>{item.message}</code>
                                                ))
                                                } */}
                                                {/* <code>
                                                    {
                                                    errorMessage.map((item, index) => (
                                                        <span map="">{item.message}</span>
                                                    ))
                                                    }
                                                </code> */}
                                            </pre>
                                            </div>
                                        </div>
                                    </div>
                                     
                                    </div>
                                    </div>
                                    <div style={{ textAlign: "center" }}>
                                        {/* ACTION BUTTONS */}
                                        <div className="action-row">
                                            {/* Added Bulk Pre-Onboard button, enabled only after successful validation */}
                                            <button
                                            className="DataAccessEdit"
                                            style={{ width: "150px" }}
                                            disabled={!isBulkValid}
                                            onClick={handleBulkPreOnboard}
                                            >
                                            <span className="ViewUpdate">Bulk Pre-Onboard</span>
                                            </button>
                                        </div>
                                    </div>
                              </>}
                          </Box>  
      </div>
    </div>
  );
};

export default PreOnboardDevices;
